export default __webpack_public_path__ + "static/adhd-be69d6a3f2d21687c981b08b7db5c207.pdf";